/* eslint-disable */
import type {
  CanMakePaymentResult as SCanMakePaymentResult,
  PaymentRequest as SPaymentRequest,
  PaymentRequestOptions as SPaymentRequestOptions,
  PaymentRequestPaymentMethodEvent,
  PaymentRequestUpdateOptions as SPaymentRequestUpdateOptions,
  Stripe as SStripe,
} from '@stripe/stripe-js';
import { logger } from '../../core/services/loggerService';

import { basketActions } from '../redux';
import { getStoreInstance } from '../Store';

declare global {
  type Stripe = SStripe;
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace Stripe {
    type PaymentRequest = SPaymentRequest;
    type PaymentRequestOptions = SPaymentRequestOptions;
    type PaymentRequestUpdateOptions = SPaymentRequestUpdateOptions;
    type CanMakePaymentResult = SCanMakePaymentResult | null;
  }
}

let stripeInstance: Stripe;
let paymentRequestInstance: Stripe.PaymentRequest;
let paymentRequestToken: string;
let stripeToken: string;

type InitProps = {
  token: string;
};
export const init = async ({ token }: InitProps) => {
  if (token === stripeToken && stripeInstance) {
    return;
  }
  const { loadStripe } = await import('@stripe/stripe-js');

  stripeToken = token;

  // console.log('[Stripe] initializing');

  stripeInstance = await loadStripe(token);

  // console.log('[Stripe] initialized');

  if (process.env.REACT_APP_ENVIRONMENT === 'development') {
    // eslint-disable-next-line no-underscore-dangle
    (window as any)._stripe_ = stripeInstance;
  }
};

export const getInstance = () => stripeInstance;

const onPaymentMethod = (event: PaymentRequestPaymentMethodEvent) => {
  const paymentId = event.paymentMethod.id;
  paymentRequestToken = paymentId;
  const store = getStoreInstance();
  store.dispatch(basketActions.continueCheckoutFlow());
  event.complete('success');
};
const onCancel = () => {
  const store = getStoreInstance();
  store.dispatch(basketActions.cancelCheckoutFlow());
};
async function createPaymentRequest(options: Stripe.PaymentRequestOptions) {
  if (!stripeInstance) {
    throw new Error('missing Stripe client instance');
  }
  paymentRequestToken = undefined;
  if (paymentRequestInstance) {
    try {
      paymentRequestInstance.off('paymentmethod', onPaymentMethod);
      paymentRequestInstance.off('cancel', onCancel);
    } catch (error) {}
  }

  paymentRequestInstance = stripeInstance.paymentRequest({
    ...options,
    requestPayerName: false,
    requestPayerEmail: false,
    requestShipping: false,
  });

  paymentRequestInstance.on('paymentmethod', onPaymentMethod);
  paymentRequestInstance.on('cancel', onCancel);

  if (process.env.REACT_APP_ENVIRONMENT === 'development') {
    // eslint-disable-next-line no-underscore-dangle
    (window as any)._stripe_payment_request_ = paymentRequestInstance;
  }
}

async function canMakePayment() {
  const canPay = await paymentRequestInstance.canMakePayment();
  return canPay;
}

function updatePaymentRequest(options: Stripe.PaymentRequestUpdateOptions) {
  paymentRequestInstance.update(options);
}

function showPaymentRequest() {
  paymentRequestInstance.show();
}

function getPaymentToken() {
  return paymentRequestToken;
}

export const paymentRequest = {
  create: createPaymentRequest,
  update: updatePaymentRequest,
  show: showPaymentRequest,
  canMakePayment,
  getPaymentToken,
};
